import { MAP_LAYER } from 'components/Map/constants';

export const MIRROR_CONTAINER_TEST_ID = 'mapFeatureMirrors';

export const MIRROR_TEST_ID = {
    APPLY_CIRCLE_BOUNDARY: 'applyCircleBoundary',
    APPLY_POLYGON_BOUNDARY: 'applyPolygonBoundary',
    BOUNDARY_VERTEX: 'boundaryVertex',
    FLIGHT_PATH: 'flightPath',
    FLIGHT_PATH_HIGHLIGHTED: 'flightPathHighlighted',
    NO_ENTRY_CIRCLE_BOUNDARY: 'noEntryCircleBoundary',
    NO_ENTRY_POLYGON_BOUNDARY: 'noEntryPolygonBoundary'
} as const;

export const BOUNDARY_LAYERS = [
    MAP_LAYER.STATIC_BOUNDARY_FILL,
    MAP_LAYER.STATIC_OBSTACLE_FILL,
    MAP_LAYER.COMPLETED_BOUNDARY_FILL,
    MAP_LAYER.COMPLETED_OBSTACLE_FILL,
    MAP_LAYER.DRAWING_BOUNDARY_POLYGON_FILL,
    MAP_LAYER.DRAWING_OBSTACLE_POLYGON_FILL,
    MAP_LAYER.DRAWING_BOUNDARY_CIRCLE_FILL,
    MAP_LAYER.DRAWING_OBSTACLE_CIRCLE_FILL
];

export const FLIGHT_PATH_LAYERS = [MAP_LAYER.FLIGHT_PATH_LINE];

export const FLIGHT_HIGHLIGHT_LAYERS = [MAP_LAYER.FLIGHT_PATH_HIGHLIGHT_LINE];
